// Sibling products encode logo colors; Color and Size keep their Shopify variant IDs.
document.addEventListener('click', async event => {
  const link = event.target.closest?.('[data-rk-three-url]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (link.hasAttribute('aria-current')) return;
  const wrapper = link.closest('[data-rk-three-logo-picker]');
  const picker = wrapper.closest('variant-picker');
  const status = wrapper.querySelector('[role="status"]');
  const chosen = name => [...picker.querySelectorAll('input[data-option-name]:checked, select option:checked')].find(input => input.dataset.optionName === name)?.value;
  const color = chosen('Color'), size = chosen('Size');
  if (!color || !size) return;
  const target = new URL(link.href, location.origin);
  for (const key of ['preview_theme_id', 'pb']) {
    const value = new URL(location.href).searchParams.get(key);
    if (value) target.searchParams.set(key, value);
  }
  status.textContent = wrapper.dataset.loading;
  link.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${link.pathname}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('load');
    const product = await response.json();
    const variant = product.variants.find(item => item.option1 === color && item.option2 === size && item.available);
    if (!variant) { status.textContent = wrapper.dataset.unavailable; return; }
    target.searchParams.set('variant', variant.id);
    location.assign(target.toString());
  } catch {
    status.textContent = wrapper.dataset.error;
  } finally { link.removeAttribute('aria-busy'); }
});
